import 'moment/locale/zh-cn';

import { ConfigProvider } from 'antd';
import zh_CN from 'antd/lib/locale-provider/zh_CN';
import moment from 'moment';
import React from 'react';
import { ApolloProvider } from 'react-apollo';
import reactDom from 'react-dom';
import { HashRouter as Router } from 'react-router-dom';
import { injectGlobal, ThemeProvider } from 'styled-components';
import styledNormalize from 'styled-normalize';

import App from './App';
import { client } from './services/api';
import { baseTheme } from './themes/baseTheme';

const globalStyle = () => injectGlobal`
  ${styledNormalize}
`;

const render = () => {
  globalStyle();
  moment.locale('zh-cn');
  reactDom.render(
    <ConfigProvider locale={zh_CN}>
      <ThemeProvider theme={baseTheme}>
        <ApolloProvider client={client}>
          <Router>
            <App />
          </Router>
        </ApolloProvider>
      </ThemeProvider>
    </ConfigProvider>,
    document.getElementById('root') as HTMLElement,
  );
};

render();



// WEBPACK FOOTER //
// ./src/index.tsx